<template>
  <div class="simple-markdown" v-html="html" />
</template>

<script setup>
import { computed } from 'vue';
import { renderMd } from '@/utils/checkout/converter';

defineOptions({ name: 'SimpleMarkdown' });

const props = defineProps({
  source: {
    type: String,
    default: '',
  },
});

const html = computed(() => renderMd(props.source));
</script>
